import {
  useCartAndDeliveryDatesDataContext,
  useCurrency,
} from '@app/data/clients/cartCheckoutClient';
import { monolithItemToAnalyticsItem } from '@app/utils/analytics';
import { useMemo } from 'react';

export const useAnalyticsCartItems = () => {
  const { cart } = useCartAndDeliveryDatesDataContext();
  const currency = useCurrency();

  const showTaxSeparately = cart?.summary.show_tax_separately ?? false;

  return useMemo(
    () =>
      cart?.items.map((item, index) =>
        monolithItemToAnalyticsItem(item, currency, index, showTaxSeparately)
      ),
    [cart?.items, currency, showTaxSeparately]
  );
};
